exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-checkout-steps-modals-styles-___fraudulent-order-modal__modalBody___3ExNg{display:flex;flex-direction:column}.src-components-checkout-steps-modals-styles-___fraudulent-order-modal__headerInfo___1pZpb{margin-top:20px;flex-direction:row}.src-components-checkout-steps-modals-styles-___fraudulent-order-modal__headerInfo___1pZpb a{color:#1f73b7}.src-components-checkout-steps-modals-styles-___fraudulent-order-modal__bodyInfo___3TUhM{margin-top:10px}.src-components-checkout-steps-modals-styles-___fraudulent-order-modal__caseNumber___13pIh{color:#000;margin-left:5px}", ""]);

// exports
exports.locals = {
	"modalBody": "src-components-checkout-steps-modals-styles-___fraudulent-order-modal__modalBody___3ExNg",
	"headerInfo": "src-components-checkout-steps-modals-styles-___fraudulent-order-modal__headerInfo___1pZpb",
	"bodyInfo": "src-components-checkout-steps-modals-styles-___fraudulent-order-modal__bodyInfo___3TUhM",
	"caseNumber": "src-components-checkout-steps-modals-styles-___fraudulent-order-modal__caseNumber___13pIh"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/sass-loader!./src/components/checkout-steps/modals/styles/fraudulent-order-modal.scss
 ** module id = 888
 ** module chunks = 0
 **/